import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import i18n from './i18n';
import { createPinia, PiniaVuePlugin } from 'pinia';
import VueClipboards from 'vue-clipboards';

Vue.config.productionTip = false;

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

Vue.use(VueClipboards);

new Vue({
  vuetify,
  pinia,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
